import { paymentBankLinksSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { PaymentBankLinks } from '../../model/payment-bank-links.js';
import type { PaymentBankLinksDto } from '../dto/payment-bank-links.dto.js';
import { toPaymentBankLinks } from '../mappers/payment-bank-links.mapper.js';

const fetchPaymentBankLinks = async (
  paymentId: string,
  signal: AbortSignal,
): Promise<PaymentBankLinksDto> =>
  paymentBankLinksSchema.parse(
    await apiRequest<unknown>(`/bank/payments/${paymentId}/links`, { signal }),
  );

export const getPaymentBankLinks = async (
  paymentId: string,
  signal: AbortSignal,
): Promise<PaymentBankLinks> => toPaymentBankLinks(await fetchPaymentBankLinks(paymentId, signal));
